import logo from "../../../../assets/img/MM_Onboarding_Logo.png";
import { Button } from "react-blueprint-library";

function ConfidentialAppHeader(props) {
  const handleExitClick = () => {
    window.close();
  };

  const handlePrintClick = () => {
    props.printFunction();
  };
  return (
    <>
      <div id="confidential-app-header">
        <div className="row">
          <div className="col-md-5">
            <img alt="MassMutual" src={logo} />
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-5">
            <Button
              id="confidential_app_print_button"
              variant={"primary"}
              onClick={handlePrintClick}
            >
              EXPORT PDF
            </Button>
            <Button
              id="confidential_app_exit_button"
              onClick={handleExitClick}
              variant={"tertiary"}
            >
              <strong>Exit</strong>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfidentialAppHeader;
